import { Component } from '@angular/core';

@Component({
    selector: 'sections',
    templateUrl: 'sections.component.html',
})
export class SectionsComponent {
}



// WEBPACK FOOTER //
// ./src/app/components/sections/sections.component.ts